import React, { Component } from 'react';
import moment from 'moment'
import firebase from 'firebase/app';
import { firebaseApp } from './firebase/';

import Jumbotron from 'react-bootstrap/Jumbotron'
import Badge from 'react-bootstrap/Badge';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from 'react-toastify'
import { Collapse } from 'react-collapse'
import { Link } from "react-router-dom"

import {
  SignInButtons,
  saveSignInParam,
  onAuthStateChanged,
} from './task/SignInButtons'
import UserNavbar from './task/UserNavbar'
import RecentTasks from './task/RecentTasks'
import RecentContents from './task/RecentContents'
import ContentAlert from './task/ContentAlert'
import CollapseLabel from './task/CollapseLabel'
import YouTubeLink from './task/YouTubeLink'
import GarminSummary from './activity/GarminSummary'
import Footer from './task/Footer'
import { Recommends, getRecommendedTasks, getRecommendedQuizs } from './task/Recommends'

import './RecentApp.css';


const MAX_RECOMMEND = 3
const db = firebaseApp.firestore();

class RecentApp extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href
    this.state = {
      baseURL: url.substring(0, url.indexOf('/recent/')),
      user: null,
      loading: true,
      error: null,
      tasks: null,
      contents: null,
      openGarmin: false,
      openRecommends: true,
      openTasks: true,
      openContents: true,
    };
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  componentDidMount() {
    onAuthStateChanged(this.auth(), (user, error) => {
      if (error) {
        this.setState({
          error,
        });
        return;
      }
      this.loadTasks(user)
        .then(result => {
            this.setState({
              loading: false,
              user,
              tasks: result.tasks,
              contents: result.contents,
              alerts: result.alerts,
              userData: result.userData,
              userStats: result.userStats,
              recommended: result.recommended,
              images: result.images,
            })
        }).catch((error) => {
          console.error(error)
          this.setState({
            loading: false,
            error: error.message || error,
          })
        })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.emitErrorToast(prevState)
  }

  emitErrorToast(prevState) {
    if (prevState.error === this.state.error || this.state.error === null) {
      return
    }
    toast.error(`Error: ${this.state.error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => this.setState({
        error: null
      })
    })
  }

  signIn(provider) {
    this.auth().signInWithRedirect(provider)
  }

  signOut() {
    this.auth().signOut()
      .then(() => {
        this.setState({
          user: null,
        });
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  async loadTasks(user) {
    if (user === null) {
      return {
        tasks: [],
        contents: [],
      }
    }
    const userRef = await db
      .collection('user').doc(user.uid).get()
    const userData = await saveSignInParam(db.collection('user'), userRef)
    const userStats = await db
      .collection('userstats').doc(user.uid).get()
    const taskRefs = await db
      .collection('user').doc(user.uid)
      .collection('taskref').orderBy('accessed', 'desc').get()
    const contentsRefs = await this.loadContents(db, user)
    const alerts = await this.loadAlerts(user)
    const recommendedTasks = await getRecommendedTasks(
      db, user.uid, taskRefs.docs, MAX_RECOMMEND, new Date()
    )
    const recommendedQuizs = await getRecommendedQuizs(
      db, user.uid, taskRefs.docs, MAX_RECOMMEND, new Date()
    )
    const contents = await Promise.all(contentsRefs
      .map(contentsRef => db.collection('contents').doc(contentsRef.id).get()))
    const images = {};
    const contentsData = [];
    contents.forEach((content) => {
      contentsData.push(content.exists ? content.data() : {})
      if (!content.exists) {
        return
      }
      (content.data()['cloze'] || []).forEach((cloze, index) => {
        images[cloze] = (content.data()['thumbnails'] || [])[index]
      })
    })
    return {
      tasks: taskRefs.docs.map(taskRef => ({
        id: taskRef.id,
        data: taskRef.data(),
      })),
      contents: contentsRefs.map((contentsRef, contentsIndex) => ({
        id: contentsRef.id,
        data: Object.assign({}, contentsRef.data(), contentsData[contentsIndex] || {}),
      })),
      alerts,
      userData,
      images,
      userStats: userStats.exists ? userStats.data() : null,
      recommended: {
        tasks: recommendedTasks.map((taskRef) => ({
          id: taskRef.id,
          data: taskRef.data(),
        })),
        quizs: recommendedQuizs.map((taskRef) => ({
          id: taskRef.id,
          data: taskRef.data(),
        })),
      }
    }
  }

  async loadContents(db, user) {
    const contentsRefRecords = await db
      .collection('user').doc(user.uid)
      .collection('contentsref').orderBy('accessed', 'desc').get()
    const contentsRefRecordIds = contentsRefRecords.docs.map((contentsRef) => contentsRef.id)
    const contentsRefRecommends = await db
      .collection('contents').where('recommended', '==', true).get()
    const userDomain = user.email.indexOf('@') > 0 ? user.email.substring(user.email.indexOf('@')) : null
    const contentsRefRecommendsList = contentsRefRecommends.docs
      .filter((contentsRef) => contentsRef.data().whitelist_auth)
      .filter((contentsRef) => contentsRef.data().whitelist_auth.split(';').includes(userDomain))
      .filter((contentsRef) => !contentsRefRecordIds.includes(contentsRef.id))
    return contentsRefRecords.docs.concat(contentsRefRecommendsList)
  }

  async loadAlerts(user) {
    const publicAlerts = await db
      .collection('alert')
      .where('public', '==', true)
      .get()
    const domainAlerts = user.email.includes('@') ? (await db
      .collection('alert')
      .where('domain', '==', user.email.substring(user.email.indexOf('@')))
      .get()) : { docs: [] }
    const serializeAlert = (alert) => ({
      id: alert.id,
      variant: alert.data().variant,
      title: alert.data().title,
      message: alert.data().message,
      visible: alert.data().visible,
    })
    return domainAlerts.docs.map(serializeAlert)
      .concat(publicAlerts.docs.map(serializeAlert))
      .filter((alert) => alert.visible)
  }

  renderIntroduction() {
    return <div>
      <p>Cloze Testは、一部が空欄になった文章を穴埋めすることで解くスタイルの英語問題です。</p>
      <p>
        <YouTubeLink title="使い方動画(YouTube)" youtubeid="DOT9vOMHols" />
      </p>
    </div>
  }

  renderAlerts() {
    return (this.state.alerts || []).map((alert) => <ContentAlert
        key={alert.id}
        variant={alert.variant}
        title={alert.title}
        message={alert.message}
      />)
  }

  renderGarmin() {
    const userStats = this.state.userStats || {}
    const updated = userStats.untilStress || userStats.untilSleep
    const expired = updated && (moment(new Date(updated)) < moment(new Date()).subtract({
      days: 2,
    }))
    return <div>
      <CollapseLabel
        title={<span>
          Garminの装着状況<span> </span>
          {expired && <Badge variant='danger'>タップしてメッセージを確認</Badge>}
        </span>}
        isOpened={this.state.openGarmin}
        onClick={(prevOpened) => this.setState({ openGarmin: !prevOpened })}
      />
      <Collapse isOpened={this.state.openGarmin}>
        <GarminSummary
          userStats={this.state.userStats}
          expired={expired}
        />
      </Collapse>
    </div>
  }

  render() {
    return <div>
      <UserNavbar
        incompleteTasks={this.state.tasks !== null ? this.state.tasks.filter(task => !task.data.completed) : null}
        user={this.state.user}
        onSignOut={() => this.signOut()}/>
      <div className='RecentApp'>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />
        {this.state.loading ? <div className='Loading'>
          <ClipLoader />
          <div>Loading...</div>
        </div> : (this.state.user === null ? <div className='Login'>
          <Jumbotron>
            <h1>Cloze Testアプリ</h1>
            <SignInButtons
              description='Cloze Testアプリを使用するためには、'
              signIn={(provider) => this.signIn(provider)}
            />
          </Jumbotron>
          <h2>Cloze Testアプリの使い方</h2>
          {this.renderIntroduction()}
        </div> : <div>
          <Jumbotron>
            <h1>Cloze Testアプリ</h1>
            <p>
              小説、ニュース記事など『読みたい文章』を使って英語学習をしてみましょう。<br/>
              {(this.state.contents && this.state.contents.length > 0) ?
                '以下の 利用可能なコンテンツリスト からコンテンツを選択するか、' :
                <>
                  <Link to='/dashboard/'>ダッシュボード</Link> からCloze Testを作成するか、
                </>}
              過去に実施した問題の続きを解いてみましょう！
            </p>
          </Jumbotron>
          {this.renderAlerts()}
          {this.state.userData.garminUser && this.renderGarmin()}
          {this.state.recommended &&
            ((this.state.recommended.tasks && this.state.recommended.tasks.length > 0)
              || (this.state.recommended.quizs && this.state.recommended.quizs.length > 0)) &&
            <>
              <CollapseLabel
                title='おすすめ'
                isOpened={this.state.openRecommends}
                onClick={(prevOpened) => this.setState({ openRecommends: !prevOpened })}
              />
              <Collapse isOpened={this.state.openRecommends}>
                <Container>
                  <Row className='h-100'>
                    <Recommends
                      baseURL={this.state.baseURL} type='cloze' items={this.state.recommended.tasks}
                      images={this.state.images}
                    />
                    <Recommends
                      baseURL={this.state.baseURL} type='quiz' items={this.state.recommended.quizs}
                      images={this.state.images}
                    />
                  </Row>
                </Container>
              </Collapse>
            </>}
          <CollapseLabel
            title='最近実施したCloze Test'
            isOpened={this.state.openTasks}
            onClick={(prevOpened) => this.setState({ openTasks: !prevOpened })}
          />
          <Collapse isOpened={this.state.openTasks}>
            <RecentTasks
              baseURL={this.state.baseURL} tasks={this.state.tasks}
              images={this.state.images}
            />
          </Collapse>
          <CollapseLabel
            title='利用可能なコンテンツリスト'
            isOpened={this.state.openContents}
            onClick={(prevOpened) => this.setState({ openContents: !prevOpened })}
          />
          <Collapse isOpened={this.state.openContents}>
            <RecentContents baseURL={this.state.baseURL} contents={this.state.contents} />
          </Collapse>
        </div>)}
      </div>
      <Footer />
    </div>
  }
}

export default RecentApp;
